import { render, staticRenderFns } from "./PcoEmailsQueuePage.vue?vue&type=template&id=5ebdbe54"
import script from "./PcoEmailsQueuePage.vue?vue&type=script&lang=js"
export * from "./PcoEmailsQueuePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports